/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ManagerType } from './';
import {
    ManagerTypeFromJSON,
    ManagerTypeFromJSONTyped,
    ManagerTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateManagerRequest
 */
export interface UpdateManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateManagerRequest
     */
    managerId: string;
    /**
     * 
     * @type {ManagerType}
     * @memberof UpdateManagerRequest
     */
    managerType: ManagerType;
}

/**
 * Check if a given object implements the UpdateManagerRequest interface.
 */
export function instanceOfUpdateManagerRequest(value: object): value is UpdateManagerRequest {
    if (!('managerId' in value) || value['managerId'] === undefined) return false;
    if (!('managerType' in value) || value['managerType'] === undefined) return false;
    return true;
}

export function UpdateManagerRequestFromJSON(json: any): UpdateManagerRequest {
    return UpdateManagerRequestFromJSONTyped(json, false);
}

export function UpdateManagerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateManagerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'managerId': json['managerId'],
        'managerType': ManagerTypeFromJSON(json['managerType']),
    };
}

export function UpdateManagerRequestToJSON(value?: UpdateManagerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'managerId': value['managerId'],
        'managerType': ManagerTypeToJSON(value['managerType']),
    };
}

